import React from 'react';
import PropTypes from 'prop-types';

import getDateRange from '@brandwatch/date-ranges';
import resolveProps from '@vizia/resolve-props';

const ViziaComponentHeader = ({
  folderOptions = {},
  options = {},
  name
}) => {
  const resolvedProps = resolveProps({
    ...folderOptions,
    ...options
  });
  const { label: dateRange } = getDateRange(resolvedProps);

  return (
    <div className="ViziaComponent__header">
      <div className="ViziaComponent__title">{name || '…'}</div>
      {
        dateRange && (
          <div className="ViziaComponent__dateRange">{dateRange}</div>
        )
      }
    </div>
  );
};

ViziaComponentHeader.propTypes = {
  name: PropTypes.string,
  folderOptions: PropTypes.object,
  options: PropTypes.object
};

export default ViziaComponentHeader;
